import React from 'react';

/** Section card shared by every block on the filing page. */
export const FilingPanel = ({ id, title, icon: Icon, action, note, children, className = '' }) => (
  <section aria-labelledby={id} className={`bg-white rounded-2xl border border-slate-200/90 shadow-sm ${className}`}>
    <div className="flex flex-wrap items-center justify-between gap-2 px-4 sm:px-5 py-3 border-b border-slate-100">
      <h2 id={id} className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-wider text-slate-600">
        {Icon && <Icon className="w-4 h-4 text-[#008080]" aria-hidden="true" />}
        {title}
      </h2>
      {action}
    </div>
    <div className="p-4 sm:p-5">{children}</div>
    {note && <p className="px-4 sm:px-5 pb-4 -mt-1 text-[11px] text-slate-400 leading-relaxed">{note}</p>}
  </section>
);

/** Label/value pair used across the detail grids. */
export const FilingFact = ({ label, value, hint }) => (
  <div className="min-w-0">
    <dt className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{label}</dt>
    <dd className="mt-1 text-sm font-bold text-slate-900 break-words">
      {value}
      {hint && <span className="ml-1.5 text-[10px] font-semibold text-amber-600">{hint}</span>}
    </dd>
  </div>
);

/** Years across the top, metrics down the side. */
export const YearTable = ({ years, rows, caption }) => (
  <div className="overflow-x-auto scrollbar-slim">
    <table className="w-full text-left border-collapse">
      {caption && <caption className="sr-only">{caption}</caption>}
      <thead>
        <tr className="border-b border-slate-200/80 text-[10px] font-bold uppercase tracking-wider text-slate-500">
          <th scope="col" className="py-2 pr-3 min-w-[170px]">
            Metric
          </th>
          {years.map((year) => (
            <th key={year} scope="col" className="py-2 px-3 text-right whitespace-nowrap">
              {year}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100 text-[13px]">
        {rows.map((row) => (
          <tr key={row.label}>
            <th scope="row" className="py-2.5 pr-3 font-semibold text-slate-600 capitalize">
              {row.label}
            </th>
            {row.cells.map((cell, index) => (
              <td key={years[index]} className="py-2.5 px-3 text-right tabular-nums font-bold text-slate-900 whitespace-nowrap">
                {cell || <span className="font-normal text-slate-300">—</span>}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FilingPanel;
